import { AuthenticationState } from '../../store/authentication/state';
import { AgeCategory } from '../../../models/AgeCategory';
import Utils from '../utils';

// list of all default visible filter groups. the order is not important.
// the rendering order is handled by the ResponsiveFilterBar itself.
export const defaultVisibleFilterGroups = (authentication: AuthenticationState, ageCategory?: AgeCategory) => [
    'quickfilters',
    'status',
    'collectionQuickfilters',
    'reserves',
    'loanFormat',
    'ageCategory',
    'ageGroup',
    'genre',
    'explicit',
    'series',
    'author',
    'authorCountry',
    'narrator',
    'bestseller',
    'award',
    'awardYear',
    'selection',
    'releaseDate',
    'releaseFrequency',
    'releaseQuantity',
    'pages',
    'duration',
    'productionFormat',
    'illustrated',
    'publisher',
    'publisherImprint',
    'lendingModel',
    'multiUsageCondition',
    'language',
    'mucPrice',
    ...(ageCategory && ageCategory !== AgeCategory.ALL_AGES ? [] : ['ageCategory']),
    ...(Utils.isUserAdmin(authentication) ? ['contentProviderKey', 'productFormat'] : [])
];
